// Global PDF görüntüleyici event bus'ı.
// previewPdf() bir blob URL ürettikten sonra bu bus üzerinden
// <PdfViewerPortal /> bileşenine mesaj yollar; portal da modal olarak açar.
// Popup blocker yok, tab açma yok — her yerde stabil çalışır.

const target = new EventTarget();
export const PDF_VIEW_EVENT = "pdf:view";

export function showPdf({ url, filename }) {
  target.dispatchEvent(new CustomEvent(PDF_VIEW_EVENT, { detail: { url, filename } }));
}

export function onShowPdf(handler) {
  const listener = (e) => handler(e.detail);
  target.addEventListener(PDF_VIEW_EVENT, listener);
  return () => target.removeEventListener(PDF_VIEW_EVENT, listener);
}
